import { Track } from 'models/Track';

export function isRequestTypeTrack(value: string | Track): value is Track {
  return typeof value === 'object' && value !== null && 'title' in value;
}
